<script lang="ts" setup>
import type { Usuario } from "@/types/Usuario";
import { ref, onMounted, watchSyncEffect, computed, getCurrentInstance, watch, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { switchs } from "./data";
const app = getCurrentInstance();
const { $http, $vistra } = app!.appContext.config.globalProperties;

// import { useTheme, type ThemeProps } from "@/store";
type Props = {
  positionRightSelected: string,
  salvar?: boolean
}
let props = defineProps<Props>();

type Emits = {
  (e: "onChange", theme: string): void;
};
const emit = defineEmits<Emits>();

const store = useStore();

const bullet = ref<HTMLSpanElement | null>(null);
const buttons = ref<HTMLButtonElement[]>([]);

const usuario = computed((): Usuario => store.state.usuario);
const state = ref();

const setDadosUsuario = (usuario: Usuario) => store.dispatch('setDadosUsuario', usuario);

const setTemaVistra = (modoEscuro: boolean) =>  {
  state.value = modoEscuro ? 'dark' : 'light'
  usuario.value.modoEscuro = modoEscuro;
  if (props.salvar) {
    setDadosUsuario(usuario.value)
    confirmTheTheme();
    store.dispatch('temaVistra', modoEscuro)
  } else
    store.dispatch('temaVistraLocal', modoEscuro)
  
  emit('onChange', state.value)
};

const confirmTheTheme = () => {
    $http.put("/Usuario/UpdateTemaProprioUsuario/"+ usuario.value.modoEscuro)
    .then(response => {
        if (!!response.data.msgErro) {
            $vistra.showMessage(response.data.msgErro, "error");   
        }
        
    }).catch((e: any) => {
        $vistra.showMessage(!e.data.msgErro ? e : e.data.msgErro, "error");                    
    })              
}

const update = () => {
  const el = buttons.value[state.value === "dark" ? 0 : 1];

  if (el && bullet.value) {
    bullet.value.style.width = '50%';
    if(state.value == 'dark')
      bullet.value.style.left = `${el.offsetLeft}px`;
    else
      // bullet.value.style.left = `${props.positionRightSelected || el.offsetLeft}px`;
      bullet.value.style.left = `50%`;
  }
};
onMounted(() => {
  state.value = store.getters.tema == 'tema-dark' ? 'dark' : 'light'
  window.addEventListener("resize", update);
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", update);
});
watch([() => props.positionRightSelected, state], () => {
  update();
});
watchSyncEffect(() => {
  update();
});
</script>

<template>
  <div
    class="toggle-theme w-full flex h-8 relative items-center bg-gray-100 dark:bg-gray-800 rounded-full"
  >
    <button
      v-for="({ icon, label }, index) in switchs"
      type="button"
      ref="buttons"
      :key="label"
      class="toggle-theme-item w-2/4 justify-center text-center px-4 h-full relative z-10 flex text-xs font-semibold items-center rounded-full transition-all duration-300 ease-in-out"
      @click="() => setTemaVistra(index === 0)"
      :class="
        (index === 0 && state === 'dark') || (index === 1 && state === 'light')
          ? 'text-white'
          : 'text-gray-400'
      "
    >
      <component :is="icon" class="mr-2" />

      {{ label }}
    </button>

    <span
      ref="bullet"
      class="bg-primary-500 z-0 transition-all duration-300 ease-in-out absolute h-full rounded-full"
    ></span>
  </div>
</template>
